<template>
	<div>
		<SliderLayout
			header-display-icon
			:min-height="minHeight()"
		>
			<div v-if="!submitted">
				<div>
					<helio-message
						class="forgot-password__error"
						:active="error.description.length > 0 && error.title.length > 0"
						icon-token="exclamation-circle"
						icon-weight="bold"
						state="danger"
						:title="error.title"
						@close="() => {error.title = ''; error.description = ''}"
					>
						<template v-slot:content>
							<p>
								{{ error.description }}
							</p>
						</template>
					</helio-message>
					<div class="forgot-password__title">
						{{ translation['new-password'] }}
					</div>
					<div class="forgot-password__desc">
						{{ translation['password-message'] }}
					</div>
				</div>
				<div class="forgot-password__input">
					<helio-field
						class="input__height"
						data-cy="forgot-password-field"
						:display-success="false"
						:label="translation['linked-address']"
						large="large"
						type="email"
						@changed="email = $event"
						@errors="errors = $event"
						@keyup.enter.native="(!sendDisabled)?sendEmail():()=>{}"
					/>
					<helio-button
						:disabled="sendDisabled"
						class="forgot-password__button"
						data-cy="submit-button"
						color="primary"
						:text="translation['submit']"
						size="large"
						:state="buttonState"
						@click="sendEmail()"
					/>
					<router-link
						class="forgot-password__back-to-login"
						data-cy="back-to-login"
						:to="{name: `login-${$i18n.locale}`}"
					>
						{{ translation['back-to-login'] }}
					</router-link>
				</div>
			</div>
			<div
				v-else
				class="forgot-password__content"
			>
				<div>
					<div
						class="forgot-password__title"
						data-cy="instructions-sent"
					>
						{{ translation['instructions-sent'] }}
					</div>
					<div
						class="forgot-password__desc"
						data-cy="instructions-sent--message"
					>
						{{ translation['instructions-message-part-1'] }}
						<strong class="forgot-password__email">
							{{ email }}.
						</strong>
						<br>
						<br>
						{{ translation['instructions-message-part-2'] }}
					</div>
				</div>
				<div class="forgot-password__input">
					<helio-button
						class="forgot-password__button"
						data-cy="return-button"
						color="primary"
						:text="translation['back-to-login']"
						size="large"
						:state="buttonState"
						@click="backToLogin()"
					/>
				</div>
			</div>
		</SliderLayout>
	</div>
</template>

<script>
import { translationMixin, titleMixin } from '../../mixins';

import SliderLayout from '@/views/SliderLayout';

export default {
	name: 'ForgotPassword',
	components: {
		SliderLayout,
	},
	mixins: [translationMixin, titleMixin],
	data() {
		return {
			submitted: false,
			email: '',
			errors: [],
			enableForgotPassword: true,
			error: {
				title: '',
				description: '',
			},
		};
	},
	computed: {
		translation() {
			return this.currentTranslation['forgot-password'];
		},

		loginLink() {
			return this.currentTranslation.names.login;
		},

		sendDisabled() {
			return this.email.length === 0 || this.errors.length > 0;
		},

		buttonState() {
			if (this.errors.length > 1) {
				return 'is-unsuccessful';
			}
			if (this.submitted) {
				return 'is-successful';
			}
			if (!this.enableForgotPassword) {
				return 'is-loading';
			}
			return null;
		},

		isErrorPresent() {
			return this.error.description.length > 0 && this.error.title.length > 0;
		},
	},
	beforeDestroy() {
		const forgotPasswordError = {
			title: '',
			description: '',
		};
		this.$store.dispatch('application/SET_PROPERTY', { forgotPasswordError });
	},
	created() {
		this.error = this.$store.getters['application/getForgotPasswordError'];
	},
	methods: {
		minHeight() {
			return this.isErrorPresent ? 720 : 624;
		},
		sendEmail() {
			this.enableForgotPassword = false;
			this.$store.dispatch('sso/SEND_FORGOT_PASSWORD_EMAIL', {
				email: this.email,
			})
				.then(() => { this.submitted = true; })
				.catch((error) => {
					this.enableForgotPassword = true;
					throw error;
				});
		},
		backToLogin() {
			this.$router.push({ name: `login-${this.$i18n.locale}` });
		},
	},
};
</script>

<style lang="scss" src="./forgot-password.scss" />
